
import { mapGetters, mapState, mapMutations } from "vuex";

export default {
  data: () => ({
    selectedOutlet: [],
    sortList: [
      { value: "alphabetical-order", label: "Alphabetical Order" },
      { value: "time-added", label: "Time Added" },
      // { value: "custom", label: "Custom" },
      { value: "price-low-to-high", label: "Price Low to High" },
      { value: "price-high-to-low", label: "Price High to Low" }
    ]
  }),
  mounted() {
    this.selectedOutlet = JSON.parse(JSON.stringify(this.selectedRestaurants));
    // this.outletSelectionChange(false);
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("restaurant", ["locationDetails"]),
    ...mapGetters("restaurant", ["hasMultipleBrands"]),
    ...mapState("report", ["selectedRestaurants"]),
    ...mapGetters("report", ["getSelectedRestaurantsLabel"])
  },
  methods: {
    ...mapMutations("report", ["SET_REPORT_RESTAURANT", "SET_REPORT_PRODUCTS"]),
    outletSelectionChange(force) {
      this.SET_REPORT_RESTAURANT(this.selectedOutlet);
      if (force) this.SET_REPORT_PRODUCTS([]);
      this.$emit("fetchReport");
    }
  }
};
